import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ApiDataService } from "@services/http/ApiDataService";
import { AboutModel } from "../models/AboutModel";

@Injectable({
    providedIn: "root",
})
export class AboutService extends ApiDataService {
    public constructor() {
        super("about");
    }

    public getAbout(): Observable<AboutModel> {
        return this.get<AboutModel>();
    }
}